/// <amd-module name="Artifacts/Connect/types/Index" />

export * from "Artifacts/Connect/types/IProtocol";
export * from "Artifacts/Connect/types/ITool";
